import React, { useState } from 'react'
import { Form, Input, Button } from 'antd'
import './Invoice.css'
import { submitProductEnquiry } from '../../api';
import toast, { Toaster } from 'react-hot-toast';

function Invoice() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  // ================= CONTACT FORM =================
  async function handleContact(values) {
    // Validation — email ya phone mein se ek zaroori
    if (!values.email && !values['Mobile-no']) {
      toast.error("Please enter either Email or Mobile number.");
      return;
    }

    try {
      const result = await submitProductEnquiry({
        name: values.Name,
        email: values.email || "",
        phone: values['Mobile-no'] || "",
        company: '',
        product: 'Invoice',
        message: values.Address || '',
      });

      if (result.status === 'success') {
        // ✅ Toast with name
        toast.success(
          `Congratulations ${values.Name}! Your form is submitted successfully. We will respond to you as soon as possible.`,
          { duration: 5000 }
        );
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again.");
    }
  }

  return (
    <div className="inv-single-page">
      {/* ✅ Toast Container */}
      <Toaster
        position="top-right"
        containerStyle={{ top: 80, zIndex: 99999 }}
        toastOptions={{ duration: 5000, style: { fontSize: "13px", borderRadius: "10px", maxWidth: "380px" } }}
      />

      {/* ================= NAVBAR ================= */}
      <nav className="inv-navbar">
        <div className="inv-navbar-logo">
          <div className="inv-logo-icon">◈</div>
          <div>STOCK<span>LY</span><small>INVENTORY SYSTEM</small></div>
        </div>

        <div className={`inv-navbar-links ${menuOpen ? 'inv-menu-open' : ''}`}>
          <a href="#home" onClick={closeMenu}>Home</a>
          <a href="#about" onClick={closeMenu}>About</a>
          <a href="#features" onClick={closeMenu}>Features</a>
          <a href="#inventory" onClick={closeMenu}>Inventory</a>
          <a href="#contact" onClick={closeMenu}>Contact</a>
          <a href="#contact" className="inv-navbar-button inv-mobile-only" onClick={closeMenu}>Get Started<span>↗</span></a>
        </div>

        <a href="#contact" className="inv-navbar-button inv-desktop-only">Get Started<span>↗</span></a>

        <div className={`inv-hamburger ${menuOpen ? 'inv-hamburger-active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
          <span></span><span></span><span></span>
        </div>
      </nav>

      {/* HOME SECTION */}
      <section id="home" className="inv-home-section">
        <div className="inv-home-left">
          <div className="inv-home-badge"><span className="inv-badge-dot"></span>SMART INVENTORY MANAGEMENT</div>
          <h1>Manage Your<br /><span>Inventory</span><br />With Confidence.</h1>
          <p className="inv-home-text">A powerful inventory management system designed to help businesses organize products, monitor stock, track inventory movement and make smarter decisions.</p>
          <div className="inv-home-actions">
            <a href="#inventory" className="inv-home-main-btn">Explore Inventory<span>↗</span></a>
            <a href="#about" className="inv-home-outline-btn">Discover More</a>
          </div>
          <div className="inv-home-trust">
            <div className="inv-trust-avatars"><div>MK</div><div>RS</div><div>AK</div><div>+</div></div>
            <div className="inv-trust-content"><strong>Trusted Management</strong><span>Built for modern businesses</span></div>
          </div>
        </div>

        <div className="inv-home-right">
          <div className="inv-hero-glow"></div>
          <div className="inv-hero-image-box">
            <img src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=90" alt="Inventory Management" />
            <div className="inv-image-overlay"></div>
            <div className="inv-hero-top-card">
              <div className="inv-top-card-icon">✓</div>
              <div><span>Inventory Status</span><strong>All Systems Healthy</strong></div>
              <div className="inv-online-dot"></div>
            </div>
            <div className="inv-hero-stock-card">
              <span>Total Products</span>
              <div className="inv-stock-number">1,248</div>
              <div className="inv-stock-growth"><span>↗ 12.8%</span><small>vs last month</small></div>
            </div>
            <div className="inv-hero-bottom-card">
              <div className="inv-bottom-title"><span>Stock Overview</span><small>Today</small></div>
              <div className="inv-stock-bars">
                <div className="inv-bar inv-bar-one"></div><div className="inv-bar inv-bar-two"></div>
                <div className="inv-bar inv-bar-three"></div><div className="inv-bar inv-bar-four"></div>
                <div className="inv-bar inv-bar-five"></div><div className="inv-bar inv-bar-six"></div>
                <div className="inv-bar inv-bar-seven"></div>
              </div>
              <div className="inv-stock-labels">
                <span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span>
              </div>
            </div>
          </div>
          <div className="inv-products-added-card">
            <div className="inv-product-mini-icon">📦</div>
            <div className="inv-product-mini-content"><span>Products Added</span><strong>+36 Today</strong></div>
          </div>
        </div>

        <div className="inv-home-bottom-stats">
          <div className="inv-stat-item"><strong>10K+</strong><span>Products Managed</span></div>
          <div className="inv-stat-line"></div>
          <div className="inv-stat-item"><strong>99.9%</strong><span>System Reliability</span></div>
          <div className="inv-stat-line"></div>
          <div className="inv-stat-item"><strong>24/7</strong><span>Inventory Access</span></div>
          <div className="inv-stat-line"></div>
          <div className="inv-stat-item"><strong>Smart</strong><span>Business Insights</span></div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section id="about" className="inv-about-section">
        <div className="inv-about-image-area">
          <div className="inv-about-main-image"><img src="https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=90" alt="Business Team" /></div>
          <div className="inv-about-small-image"><img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=700&q=90" alt="Business Management" /></div>
          <div className="inv-about-experience-card"><strong>01</strong><div><span>Powerful</span><small>Management System</small></div></div>
          <div className="inv-about-circle"><span>SMART</span><strong>STOCK</strong></div>
        </div>

        <div className="inv-about-content">
          <div className="inv-about-tag"><span></span>ABOUT STOCKLY</div>
          <h2>Everything Your<br />Business Needs To<br /><span>Stay Organized.</span></h2>
          <p className="inv-about-intro">STOCKLY is a modern inventory management solution created to simplify the way businesses manage their products, stock and daily operations.</p>
          <p className="inv-about-description">Instead of depending on spreadsheets, notebooks or scattered information, businesses can keep important inventory data organized in one centralized system. This makes everyday management faster, clearer and more efficient.</p>
          <div className="inv-about-features">
            <div className="inv-about-feature"><div className="inv-feature-icon">◈</div><div><h3>Centralized Management</h3><p>Keep products, stock information and inventory records organized in one place.</p></div></div>
            <div className="inv-about-feature"><div className="inv-feature-icon">◇</div><div><h3>Better Visibility</h3><p>Quickly understand your inventory and keep track of what is available and what needs attention.</p></div></div>
            <div className="inv-about-feature"><div className="inv-feature-icon">↗</div><div><h3>Business Efficiency</h3><p>Reduce repetitive manual work and make daily inventory operations much easier.</p></div></div>
          </div>
          <a href="#features" className="inv-about-button">Explore Features<span>↗</span></a>
        </div>

        <div className="inv-about-bottom">
          <div><strong>01</strong><span>Simple Management</span></div>
          <div><strong>02</strong><span>Accurate Tracking</span></div>
          <div><strong>03</strong><span>Better Decisions</span></div>
          <div><strong>04</strong><span>Complete Control</span></div>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section id="features" className="inv-features-section">
        <div className="inv-features-header">
          <div className="inv-features-heading">
            <div className="inv-features-tag"><span></span>POWERFUL FEATURES</div>
            <h2>Everything You Need<br />To Manage <span>Smarter.</span></h2>
          </div>
          <p className="inv-features-intro">From product tracking to stock monitoring, STOCKLY brings all the essential tools together to make inventory management faster, easier and more reliable.</p>
        </div>

        <div className="inv-features-grid">
          <div className="inv-feature-card inv-feature-large">
            <div className="inv-feature-card-top"><div className="inv-feature-number">01</div><div className="inv-feature-card-icon">◈</div></div>
            <div className="inv-feature-card-content">
              <h3>Smart Inventory Tracking</h3>
              <p>Keep a complete overview of your products and stock levels. Know exactly what is available, what is running low and what needs attention.</p>
            </div>
            <div className="inv-inventory-mini-ui">
              <div className="inv-mini-ui-header"><span>Stock Overview</span><small>Live</small></div>
              <div className="inv-mini-stock-row"><span>Electronics</span><div className="inv-mini-progress"><div className="inv-progress-one"></div></div><strong>82%</strong></div>
              <div className="inv-mini-stock-row"><span>Accessories</span><div className="inv-mini-progress"><div className="inv-progress-two"></div></div><strong>64%</strong></div>
              <div className="inv-mini-stock-row"><span>Furniture</span><div className="inv-mini-progress"><div className="inv-progress-three"></div></div><strong>48%</strong></div>
            </div>
          </div>

          <div className="inv-feature-card">
            <div className="inv-feature-card-top"><div className="inv-feature-number">02</div><div className="inv-feature-card-icon">↗</div></div>
            <h3>Real-Time Insights</h3>
            <p>Get a clearer picture of your inventory with useful statistics and visual information.</p>
            <div className="inv-insight-chart">
              <div className="inv-chart-line inv-line-one"></div><div className="inv-chart-line inv-line-two"></div>
              <div className="inv-chart-line inv-line-three"></div><div className="inv-chart-line inv-line-four"></div>
              <div className="inv-chart-line inv-line-five"></div>
            </div>
            <div className="inv-chart-label"><span>Inventory performance</span><strong>+18.4%</strong></div>
          </div>

          <div className="inv-feature-card">
            <div className="inv-feature-card-top"><div className="inv-feature-number">03</div><div className="inv-feature-card-icon">!</div></div>
            <h3>Low Stock Alerts</h3>
            <p>Identify products that are running low before they become a problem for your business.</p>
            <div className="inv-alert-ui">
              <div className="inv-alert-item"><div className="inv-alert-dot"></div><div><strong>Wireless Mouse</strong><span>Only 08 units left</span></div><small>LOW</small></div>
              <div className="inv-alert-item"><div className="inv-alert-dot"></div><div><strong>USB Keyboard</strong><span>Only 12 units left</span></div><small>WATCH</small></div>
            </div>
          </div>

          <div className="inv-feature-card">
            <div className="inv-feature-card-top"><div className="inv-feature-number">04</div><div className="inv-feature-card-icon">#</div></div>
            <h3>Product Organization</h3>
            <p>Keep your product information structured with categories, names, descriptions and stock details.</p>
            <div className="inv-category-ui">
              <div><span>Electronics</span><strong>124</strong></div>
              <div><span>Furniture</span><strong>86</strong></div>
              <div><span>Accessories</span><strong>218</strong></div>
            </div>
          </div>

          <div className="inv-feature-card inv-feature-wide">
            <div className="inv-feature-wide-content">
              <div className="inv-feature-card-top"><div className="inv-feature-number">05</div><div className="inv-feature-card-icon">◇</div></div>
              <h3>Centralized Business Control</h3>
              <p>Manage your inventory from a single, organized system. Reduce manual work and keep important information accessible whenever you need it.</p>
            </div>
            <div className="inv-control-ui">
              <div className="inv-control-circle"><span>STOCK</span><strong>92%</strong><small>Healthy</small></div>
              <div className="inv-control-stats">
                <div><strong>1,248</strong><span>Products</span></div>
                <div><strong>326</strong><span>Categories</span></div>
                <div><strong>98%</strong><span>Accuracy</span></div>
              </div>
            </div>
          </div>
        </div>

        <div className="inv-features-bottom">
          <div><strong>01</strong><span>Track Everything</span></div>
          <div><strong>02</strong><span>Understand Data</span></div>
          <div><strong>03</strong><span>Prevent Shortages</span></div>
          <div><strong>04</strong><span>Grow Efficiently</span></div>
        </div>
      </section>

      {/* INVENTORY SECTION */}
      <section id="inventory" className="inv-inventory-section">
        <div className="inv-inventory-header">
          <div>
            <div className="inv-inventory-tag"><span></span>INVENTORY OVERVIEW</div>
            <h2>Your Stock.<br /><span>Your Control.</span></h2>
          </div>
          <p>Monitor your products, stock levels and inventory performance from one clean and organized workspace.</p>
        </div>

        <div className="inv-inventory-dashboard">
          <div className="inv-dashboard-top">
            <div><span>Overview</span><h3>Inventory Dashboard</h3></div>
            <div className="inv-dashboard-date"><span>●</span>Live Inventory</div>
          </div>

          <div className="inv-inventory-stats">
            <div className="inv-inventory-stat-card"><div className="inv-stat-icon">◈</div><div><span>Total Products</span><strong>1,248</strong></div><small>+12.8%</small></div>
            <div className="inv-inventory-stat-card"><div className="inv-stat-icon">◇</div><div><span>In Stock</span><strong>1,096</strong></div><small>+8.4%</small></div>
            <div className="inv-inventory-stat-card"><div className="inv-stat-icon">!</div><div><span>Low Stock</span><strong>86</strong></div><small className="inv-warning-text">Attention</small></div>
            <div className="inv-inventory-stat-card"><div className="inv-stat-icon">↗</div><div><span>Categories</span><strong>24</strong></div><small>+4 new</small></div>
          </div>

          <div className="inv-inventory-main-grid">
            <div className="inv-products-panel">
              <div className="inv-panel-heading">
                <div><span>PRODUCTS</span><h3>Recent Inventory</h3></div>
                <button>View All →</button>
              </div>

              <div className="inv-product-table">
                <div className="inv-product-table-head"><span>Product</span><span>Category</span><span>Stock</span><span>Status</span></div>
                <div className="inv-product-row">
                  <div className="inv-product-info"><div className="inv-product-image"><img src="https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=200&q=80" alt="Smart Watch" /></div><div><strong>Smart Watch</strong><span>STK-00124</span></div></div>
                  <span className="inv-product-category">Electronics</span><strong className="inv-product-stock">124</strong><span className="inv-status inv-available">In Stock</span>
                </div>
                <div className="inv-product-row">
                  <div className="inv-product-info"><div className="inv-product-image"><img src="https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=200&q=80" alt="Running Shoes" /></div><div><strong>Running Shoes</strong><span>STK-00281</span></div></div>
                  <span className="inv-product-category">Footwear</span><strong className="inv-product-stock">42</strong><span className="inv-status inv-available">In Stock</span>
                </div>
                <div className="inv-product-row">
                  <div className="inv-product-info"><div className="inv-product-image"><img src="https://images.unsplash.com/photo-1546435770-a3e426bf472b?auto=format&fit=crop&w=200&q=80" alt="Headphones" /></div><div><strong>Wireless Headphones</strong><span>STK-00319</span></div></div>
                  <span className="inv-product-category">Accessories</span><strong className="inv-product-stock">18</strong><span className="inv-status inv-low-stock">Low Stock</span>
                </div>
                <div className="inv-product-row">
                  <div className="inv-product-info"><div className="inv-product-image"><img src="https://images.unsplash.com/photo-1593642532400-2682810df593?auto=format&fit=crop&w=200&q=80" alt="Laptop" /></div><div><strong>Business Laptop</strong><span>STK-00412</span></div></div>
                  <span className="inv-product-category">Computers</span><strong className="inv-product-stock">67</strong><span className="inv-status inv-available">In Stock</span>
                </div>
              </div>
            </div>

            <div className="inv-inventory-side-panel">
              <div className="inv-panel-heading"><div><span>STOCK HEALTH</span><h3>Overview</h3></div><span className="inv-health-dot">●</span></div>
              <div className="inv-stock-circle"><div><strong>92%</strong><span>Healthy</span></div></div>
              <div className="inv-health-info">
                <div><span>Healthy Stock</span><strong>1,096</strong></div>
                <div><span>Low Stock</span><strong>86</strong></div>
                <div><span>Out of Stock</span><strong>66</strong></div>
              </div>
            </div>
          </div>

          <div className="inv-inventory-bottom">
            <div className="inv-inventory-chart-panel">
              <div className="inv-panel-heading"><div><span>PERFORMANCE</span><h3>Inventory Activity</h3></div><span className="inv-chart-growth">+18.4%</span></div>
              <div className="inv-bar-chart">
                <div className="inv-chart-bar inv-bar-one"><span></span></div><div className="inv-chart-bar inv-bar-two"><span></span></div>
                <div className="inv-chart-bar inv-bar-three"><span></span></div><div className="inv-chart-bar inv-bar-four"><span></span></div>
                <div className="inv-chart-bar inv-bar-five"><span></span></div><div className="inv-chart-bar inv-bar-six"><span></span></div>
                <div className="inv-chart-bar inv-bar-seven"><span></span></div>
              </div>
              <div className="inv-chart-days"><span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span></div>
            </div>

            <div className="inv-quick-panel">
              <div className="inv-panel-heading"><div><span>QUICK ACTIONS</span><h3>Manage Inventory</h3></div></div>
              <div className="inv-quick-actions">
                <div className="inv-quick-action"><div>+</div><span>Add Product</span><strong>→</strong></div>
                <div className="inv-quick-action"><div>◇</div><span>Manage Categories</span><strong>→</strong></div>
                <div className="inv-quick-action"><div>!</div><span>Check Low Stock</span><strong>→</strong></div>
              </div>
            </div>
          </div>
        </div>

        <div className="inv-inventory-bottom-text">
          <span>STOCKLY</span>
          <p>Better inventory management starts with better visibility.</p>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section id="contact" className="inv-contact-section">
        <div className="inv-contact-container">
          <div className="inv-contact-content">
            <p className="inv-contact-tag">GET IN TOUCH</p>
            <h2>Let's Talk About<br />Your <span>Business.</span></h2>
            <p className="inv-contact-description">Have questions about your inventory, stock management or business operations? Send us a message and our team will get back to you.</p>

            <div className="inv-contact-info">
              <div className="inv-contact-info-card"><div className="inv-contact-icon">✉</div><div><span>Email</span><strong>support@stockly.com</strong></div></div>
              <div className="inv-contact-info-card"><div className="inv-contact-icon">☎</div><div><span>Phone</span><strong>+91 98765 43210</strong></div></div>
              <div className="inv-contact-info-card"><div className="inv-contact-icon">⌖</div><div><span>Location</span><strong>India</strong></div></div>
            </div>
          </div>

          <div className="inv-contact-form-card">
            <div className="inv-form-heading">
              <span>CONTACT FORM</span>
              <h3>Send us a message</h3>
              <p>Fill in the details below and we'll contact you shortly.</p>
            </div>

            <Form layout="vertical" onFinish={handleContact}>
              <Form.Item label="Your Name" name="Name" rules={[{ required: true, message: 'Please enter your name' }]}>
                <Input placeholder="Enter your name" />
              </Form.Item>

              <Form.Item label="Email Address (optional)" name="email">
                <Input placeholder="you@example.com" />
              </Form.Item>

              <Form.Item label="Mobile Number (optional)" name="Mobile-no">
                <Input placeholder="Enter your mobile number" />
              </Form.Item>

              <Form.Item label="Address" name="Address" rules={[{ required: true, message: 'Please enter your address' }]}>
                <Input.TextArea rows={4} placeholder="Enter your address" />
              </Form.Item>

              {/* ✅ Button को Form.Item के अंदर रैप किया और type="primary" जोड़ा */}
              <Form.Item style={{ marginBottom: 0, marginTop: 15 }}>
                <Button type="primary" htmlType="submit" className="inv-contact-submit-btn">
                  Send Message <span>→</span>
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>

        <div className="inv-contact-bottom">
          <div><strong>01</strong><span>Quick Response</span></div>
          <div><strong>02</strong><span>Secure Data</span></div>
          <div><strong>03</strong><span>Professional Support</span></div>
          <div><strong>04</strong><span>Customer First</span></div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="inv-footer">
        <div className="inv-footer-main">
          <div className="inv-footer-company">
            <div className="inv-footer-logo">
              <div className="inv-footer-logo-icon">◈</div>
              <div>STOCK<span>LY</span><small>INVENTORY SYSTEM</small></div>
            </div>
            <p>Smart inventory management made simple. Track your stock, manage products and grow your business with confidence.</p>
            <a href="#contact" className="inv-footer-button">Get Started<span>↗</span></a>
          </div>

          <div className="inv-footer-column">
            <h3>QUICK LINKS</h3>
            <a href="#home">Home</a>
            <a href="#about">About</a>
            <a href="#features">Features</a>
            <a href="#inventory">Inventory</a>
            <a href="#contact">Contact</a>
          </div>

          <div className="inv-footer-column">
            <h3>FEATURES</h3>
            <a href="#features">Stock Tracking</a>
            <a href="#features">Inventory Analytics</a>
            <a href="#features">Product Management</a>
            <a href="#features">Smart Alerts</a>
            <a href="#features">Stock Monitoring</a>
          </div>

          <div className="inv-footer-column inv-footer-contact">
            <h3>GET IN TOUCH</h3>
            <div><span>EMAIL</span><strong>support@stockly.com</strong></div>
            <div><span>PHONE</span><strong>+91 98765 43210</strong></div>
            <div><span>LOCATION</span><strong>India</strong></div>
          </div>
        </div>

        <div className="inv-footer-bottom">
          <p>© 2026 <strong>STOCKLY</strong>. All rights reserved.</p>
          <div className="inv-footer-bottom-links"><a href="#home">Privacy</a><a href="#home">Terms</a></div>
          <p className="inv-footer-made">Built for <span>smarter</span> inventory.</p>
        </div>
      </footer>
    </div>
  )
}

export default Invoice